"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getResponsiveMode = void 0;

var _stylingConstants = require("./stylingConstants");

/**
 * Get the max Office UI Fabric `ResponsiveMode` which the window width matches.
 */
var getResponsiveMode = function getResponsiveMode() {
  var mode = 0;

  while (window.innerWidth > _stylingConstants.RESPONSIVE_MAX_CONSTRAINT[mode]) {
    ++mode;
  }

  return mode;
};

exports.getResponsiveMode = getResponsiveMode;